<template>
  <div class="page-box">
    <div class="info-box">
      <div class="confirm-info">
        <div class="icon-box">
          <img src="@/assets/img/filing/warning.png" width="100%" alt="">
        </div>
        <div class="title">短信验证重要提示</div>
      </div>
    </div>
    <div class="msg-box">
        <span class="text">
          您的核准资料我司审核无误并提交到管局后，工信部将在24小时内向您的手机发送短信验证码，您<b>【必须】</b>在24小时内根据提示打开短信连接进行验证，否则核准<b>【100%被退回】</b>
        </span>
    </div>
    <div class="button-box">
      <van-button type="primary" class="btn" @click.prevent="onSubmit">下一步</van-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    onSubmit(){
      let loading = this.$toast.loading({
        duration:0,
        overlay: true,
        forbidClick: true,
      });
      const query = this.$route.query;
      this.$apis.filingServer.submitVerify({
        verifyToken:localStorage.getItem('verifyToken'),
        userAgent:localStorage.getItem('userAgent'),
      }).then(res=>{
        loading.clear();
        if (res["code"] == 0) {
          this.$router.push({ path: '/filing/ok', query });
        } else {
          this.$dialog.alert({
            message: res['msg'],
          });
        }
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.page-box {
  max-width: 750px;
  margin: auto;
  padding: 50px;
  .info-box{
    padding-top: 100px;
    .confirm-info{
      .title{
        margin-top: 70px ;
        margin-bottom: 50px ;
        font-weight: bold;
        font-size: 32px;
        text-align: center;
      }
      .icon-box{
        width: 30%;
        margin: auto;
      }
    }
  }
  .msg-box{
    margin: 100px 0 ;
      .text{
        flex: 1;
        line-height: 50px;
        font-size: 28px;
        color: #F59A23;
      }
  }
  .button-box{
    display: flex;
    justify-content: center;
    margin-top: 40px;
    .btn{
      flex: 1;
      background-color: #4285f5;
      border-color: #4285f5;
      border-radius: 10px;
    }
  }
}
</style>
